<template>
  <div class="row">
    <div class="col-12 offset-md-3 col-md-8 col-lg-7 mb-4">
      <h2>Integrated Financial Advisory Approach</h2>
      <h3
        class="subhead gold-text mb-4"
      >Dedicated Experts in M&amp;A, Capital Raising and Restructurings</h3>
      <p>
        We provide our clients with a broad range of advisory, capital raising
        and restructuring services to the health care, real estate and related
        industries. Our combination of focused industry expertise and broad
        transactional experience uniquely positions us to offer clients unbiased
        value added advice.
      </p>
      <p>
        We also benefit from long-standing relationships with numerous dedicated
        real estate and healthcare public and private investors. Our direct
        access to these investors enables us to closely monitor market
        conditions and provide direct market insights to our clients.
      </p>
    </div>
    <div class="col-12 offset-md-3 col-md-8 col-lg-7">
      <div class="row">
        <div class="col-12 col-md-4">
          <ul>
            <li>Mergers &amp; Acquisitions</li>
            <li>Buy Side / Sell Side</li>
            <li>Fairness Opinions</li>
            <li>Activist Defense</li>
          </ul>
        </div>
        <div class="col-12 col-md-4">
          <ul>
            <li>Public Offerings</li>
            <li>Private Placements</li>
            <li>Exchange Offers</li>
            <li>Joint Ventures</li>
          </ul>
        </div>
        <div class="col-12 col-md-4">
          <ul>
            <li>Restructurings</li>
            <li>Recapitalizations</li>
            <li>Roll-ups</li>
            <li>Reorganizations</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  list-style-position: inside;
  font-family: europa, sans-serif;
  font-weight: 400;
}
</style>
